import React, { createContext } from "react"; 
const SocketContext = createContext({  
  _doubts: {},
  _messages: {}
}); 
export default SocketContext;